(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/shared/qr.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/shared/qr.js');


'use strict';

const Loader = svs.components.ReactLoader.Loader;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue;
const _svs$iam_idp$atoms = svs.iam_idp.atoms,
  activeMethodAtom = _svs$iam_idp$atoms.activeMethodAtom,
  qrCodeAtom = _svs$iam_idp$atoms.qrCodeAtom;
const QRCode = svs.components.libs.ReactQRCode;
const Qr = _ref => {
  let isPnp = _ref.isPnp;
  const activeMethod = useAtomValue(activeMethodAtom);
  const qr = useAtomValue(qrCodeAtom);
  return React.createElement("div", null, React.createElement("div", {
    className: "iam-idp-qr-code-container"
  }, qr ? React.createElement(QRCode, {
    includeMargin: false,
    size: 120,
    value: qr
  }) : React.createElement("div", null, React.createElement("p", null, "H\xE4mtar QR kod"), React.createElement(Loader, null))), React.createElement("div", {
    className: "fade-in align-center"
  }, React.createElement("h2", {
    className: "".concat(isPnp ? 'fc-white' : 'fc-black', " f-700 ")
  }, "Skanna QR-koden med ".concat(activeMethod.methodName, "-appen ").concat(activeMethod.isFreja ? '' : "eller starta ".concat(activeMethod.methodName, " p\xE5 den h\xE4r enheten.")))));
};
svs.iam_idp.components.shared.Qr = Qr;

 })(window);